import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getSaleDetail = async (params: object) => {
  return await GET({
    url: Api.getSaleDetail,
    params,
    headers: {
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const checkStock = async (params: object, bizCodeHandler, bizCodes) => {
  return await GET({
    url: Api.checkStock,
    params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false,
    bizCodeHandler,
    bizCodes
  })
}
export const getSpuParamStock = async (params: object) => {
  return await GET({
    url: Api.getSpuParamStock,
    params,
    headers: {
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const getSalePrices = async (data: object) => {
  return await POST({
    url: Api.getSalePrices,
    data,
    headers: {
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
